export default __webpack_public_path__ + "static/media/bm-logo_inner.b0552395.svg";